import React from 'react';
import DefaultButton from '../../../atoms/Buttons/DefaultButton';
import { ButtonProps } from '@mui/material';

type IconWithLabelButtonProps = {
  icon: React.ReactNode;
  label: string;
  iconPosition?: 'start' | 'end';
  onClick?: () => void;
} & ButtonProps;

export default function IconWithLabelButton({
  label,
  icon,
  iconPosition = 'start',
  ...buttonProps
}: IconWithLabelButtonProps) {
  return (
    <DefaultButton
      startIcon={iconPosition === 'start' ? icon : undefined}
      endIcon={iconPosition === 'end' ? icon : undefined}
      {...buttonProps}
    >
      {label}
    </DefaultButton>
  );
}
